module.exports = __webpack_public_path__ + "static/media/FinnosecMe.765c9c3f.png";